import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../components/Dashboard.vue'
import Members from '../components/Members.vue'
import Staff from '../components/Staff.vue'
import Ads from '../components/Ads.vue'
import Rewards from '../components/Rewards.vue'
import Comps from '../components/Comps.vue'
import Referrals from '../components/Referrals.vue'
import Campaigns from '../components/Campaigns.vue'
import Messages from '../components/Messages.vue'
import Surveys from '../components/Surveys.vue';
import Find from '../components/Find.vue'
import EditMember from '../components/editMember.vue';
import StatsPage from '../components/StatsPage.vue'
import HomeButtons from '../components/HomeButtons.vue'
import Wallets from '../components/Wallets.vue';
import WalletManager from '../components/walletManager.vue'
import CardDesigner from '../components/cardDesigner.vue'
import Cards from '../components/List/Cards.vue'
import newWallet from '../components/Wallets/newWallet.vue'
import cardPreview from '../components/Cards/Preview.vue';
import Fonts from '../components/Fonts.vue';
import Pages from '../components/Pages.vue';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Stats',
    component: StatsPage
  }, 
  {
    path: '/buttons',
    name: 'Buttons',
    component: HomeButtons
  },
  {
    path: '/members',
    name: 'Members',
    component: Members
  },
  {
    path: '/staff',
    name: 'Staff',
    component: Staff    
  },
  {
    path: '/ads',
    name: 'Ads',
    component: Ads    
  },
  {
    path: '/surveys',
    name: 'Surveys',
    component: Surveys   
  },
  {
    path: '/rewards',
    name: 'Rewards',
    component: Rewards    
  },
  {
    path: '/referrals',
    name: 'Referrals',
    component: Referrals
  },
  {
    path: '/campaigns',
    name: 'Campaigns',
    component: Campaigns
  },
  {
    path: '/comps',
    name: 'Comps',
    component: Comps
  },
  {
    path: '/messages',
    name: 'Messages',
    component: Messages
  },
  {
    path: '/:db/find',
    name: 'Find',
    component: Find
  },
  {
    path: '/members/edit/:id',
    name: 'Edit',
    component: EditMember
  },
  {
    path: '/wallets',
    name: 'Wallets',
    component: Wallets // WalletManager // Wallets
  },
  {
    path: '/pages',
    name: 'Pages',
    component: Pages
  },
  {
    path: '/cards',
    name: 'Cards',
    component: Cards
  },
  {
    path: '/walletmanager',
    name: 'wallet-manager',
    component: WalletManager
  },
  {
    path: '/carddesigner/:_id?',
    name: 'card-designer',
    component: CardDesigner
  },
  {
    path: '/pagedesigner/:_id?',
    name: 'home-desinger',
    component: CardDesigner
  },
  {
    path: '/pagedesigner/:_id?',
    name: 'page-designer',
    component: CardDesigner
  },
  {
    path: '/new/wallets',
    name: 'new-wallet',
    component: newWallet
  },
  {
    path: '/view-card/:_id',
    name: 'view-card',
    component: cardPreview
  },
  {
    path: '/fonts',
    name: 'fonts',
    component: Fonts
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
